<template>
  <RouterView />
</template>


<script>
import { getSystemLocale } from '@/helpers/functions/getSystemLocale';
import { availableLocales, defaultLocale } from '@/i18n';


const systemLocale = getSystemLocale();

export default {
  beforeRouteEnter(to, from, next) {
    // Check if the current locale is supported
    // If not check if the browser locale is supported
    // If not set to default locale (de)
    if (availableLocales.includes(to.params.locale)) return next();
    if (availableLocales.includes(systemLocale)) {
      console.warn(`Unsupported locale (${to.params.locale}), setting locale to system locale (${systemLocale})`);

      return next({
        name: to.name,
        params: {
          ...to.params,
          locale: systemLocale,
        },
        query: to.query,
      });
    }

    console.warn(`Unsupported locale (${to.params.locale}), setting locale to default locale (${defaultLocale})`);
    return next({
      name: to.name,
      params: {
        ...to.params,
        locale: defaultLocale,
      },
      query: to.query,
    });
  },
};
</script>
